<template>
  <b-container fluid class="font-jumper">

    <b-row class="mb-3">
      <b-col cols="12">
        <PageHeader title="Megszemélyesítés"/>
      </b-col>
    </b-row>

    <div v-if="!impersonationsDetails || !impersonationsDetails.originalUserId" class="mb-2 p-2" style="">
      <h4>Jelenleg senkit sem személyesítesz meg!</h4>
    </div>
    <div v-else class="mb-2">
      <div class="d-flex">
        <div class="p-2 mr-2" style="width: 420px; background-color: #ffffff; border-radius: 10px">
          <h4>A Te fiókod:</h4>
          <table>
            <tr>
              <td>Név:</td>
              <td class="px-3">{{ impersonationsDetails.originalUserName }}</td>
            </tr>
            <tr>
              <td>Email:</td>
              <td class="px-3">{{ impersonationsDetails.originalUserEmail }}</td>
            </tr>
          </table>
        </div>
        <div class="p-2" style="width: 420px; background-color: #ffffff; border-radius: 10px">
          <h4>A megszemélyesített fiók:</h4>
          <table>
            <tr>
              <td>Név:</td>
              <td class="px-3">{{ impersonationsDetails.currentUserName }}</td>
            </tr>
            <tr>
              <td>Email:</td>
              <td class="px-3">{{ impersonationsDetails.currentUserEmail }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="d-flex mt-2">
        <b-button variant="danger" @click="exitImpersonation">Kilépés a megszemélyesítésből</b-button>
      </div>
    </div>

    <div>
      <div class="table-responsive">
        <b-input-group size="sm" class="mb-3 w-50">
          <b-form-input
              debounce="600"
              placeholder="Gyorskereső..."
              class="filterInput"
              type="text"
              v-model="filter"
              id="first-element"
          />
        </b-input-group>

        <div v-if="!filter || filter.length < 3" id="second-element">A felhasználók megjelenítéséhez kérlek gépelj be legalább 3 karakter a
          keresősávba!
        </div>

        <table class="table table-hover table-striped" v-else>
          <thead>
          <tr>
            <th>Keresztnév</th>
            <th>Vezetéknév</th>
            <th>Email</th>
            <th>Cég(ek)</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(u, index) in users" :key="index">
            <td>{{ u.firstName }}</td>
            <td>{{ u.lastName }}</td>
            <td><small>{{ u.email }}</small></td>
            <td>{{ u.companies }}</td>
            <td>
              <b-button
                  variant="primary"
                  class="text-left py-1 btn-sm"
                  @click="() => loginAs(u.userId)">Belépés
              </b-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-5 d-none">
      <button id="third-element" @click="$tours['myTour'].start()" :options="tourOptions">Indítsd a túrát</button>
      <v-tour name="myTour" :steps="steps"></v-tour>
    </div>

  </b-container>
</template>

<script>
import Api from "api-client";
import PageHeader from "../../../components/PageHeader";
import Util from "@/utils/Util";

export default {
  name: "ImpersonationView",
  components: {
    PageHeader,
  },

  data() {
    return {
      impersonationsDetails: null,
      users: [],
      Util,
      filter: '',
      tourOptions: {
        useKeyboardNavigation: true,
        highlight: true,
        labels: {
          buttonSkip: 'Kihagy',
          buttonPrevious: '<',
          buttonNext: '>',
          buttonStop: 'x'
        }
      },
      steps: [
        {
          target: '#first-element',
          content: 'Ez az első lépés!'
        },
        {
          target: '#second-element',
          content: 'Ez a második lépés.',
          params: {
            highlight: true
          }
        },
        {
          target: '#third-element',
          content: 'Itt tudod a sugot barmikor megnezni ujra.',
          params: {
            highlight: true
          }
        }
      ]
    }
  },

  methods: {
    loginAs(id) {
      Api.impersonation(id).then((resp) => {
        localStorage.clear();
        localStorage.clear();
        localStorage.setItem("token", resp.data);
        Api.getMyEnabledCompanies()
            .then((companyResponse) => {
              this.$store.dispatch("app/addCompanyList", companyResponse.data);
              this.$router.push("/app/home/" + new Date().valueOf());
            })
      });
    },

    exitImpersonation() {
      Api.exitImpersonation().then((resp) => {
        localStorage.clear();
        localStorage.clear();
        localStorage.setItem("token", resp.data);
        Api.getMyEnabledCompanies()
            .then((companyResponse) => {
              this.$store.dispatch("app/addCompanyList", companyResponse.data);
              this.$router.push("/app/home/" + new Date().valueOf());
            })
      });
    }
  },

  mounted() {
    Api.getImpersonationDetails().then((resp) => this.impersonationsDetails = resp.data);

    // start the tour automatically when the component is mounted
    // this.$tours['myTour'].start();
  },

  watch: {
    filter(value) {
      if (value && value.length >= 3) {
        Api.findUsersWithCompanies(value).then((resp) => this.users = resp.data);
      }
    }
  }
};
</script>

<style scoped>
.filterInput {
  border: 1px solid #eee !important;
  background-color: white !important;
  color: grey !important;
}

::v-deep .v-step {
  background-color: red !important;
  border-radius: 24px !important;
}

.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0,0,0,.4);
}
</style>